<header
  class="navbar w-100 shadow-sm fixed-top p-2"
  [ngClass]="{ 'bg-dark': darkModeService.isDarkModeOn() }"
>
  <div class="row w-100">
    <div class="col-3 ps-3">
      <a href="">
        <div class="logo-container">
          <img src="assets/FXCH.v2.1.png" alt="fxch-logo" height="100%" />
        </div>
      </a>
    </div>

    <div class="col"></div>
    <div class="col-1 pt-1 me-4">
      <baxter-library-profile
        [fillColor]="darkModeService.isDarkModeOn() ? 'white' : '#000000'"
        [darkModeService]="darkModeService"
        [gridColumnLayout]="24"
        [navigateAfterLogout]="'login'"
      ></baxter-library-profile>
    </div>
  </div>
</header>

<div class="container functions">
  <h1 class="text-primary">Core Functions</h1>
  <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4">
    <div
      class="col"
      *ngFor="let f of coreFunctions | permission: currentUser.permissions"
    >
      <a [routerLink]="'/' + f.path" *ngIf="f.disabled === false">
        <div
          class="card h-100 text-center"
          [ngClass]="{ 'dark-skin': darkModeService.isDarkModeOn() }"
        >
          <h5 class="card-title">{{ f.name }}</h5>
          <p class="card-text"><i class="fa fa-2x {{ f.icon }}"></i></p>
        </div>
      </a>

      <div class="card h-100 text-center disabled" *ngIf="f.disabled === true">
        <h5 class="card-title">{{ f.name }}</h5>
        <p class="card-text"><i class="fa fa-2x {{ f.icon }}"></i></p>
      </div>
    </div>
    <!-- // cols-->
  </div>
  <!-- // row-->

  <h1 class="text-primary">Other Functions</h1>
  <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4">
    <div
      class="col"
      *ngFor="let f of otherFunctions | permission: currentUser.permissions"
    >
      <a [routerLink]="'/' + f.path" *ngIf="f.disabled === false">
        <div
          class="card h-100 text-center"
          [ngClass]="{ 'dark-skin': darkModeService.isDarkModeOn() }"
        >
          <h5 class="card-title">{{ f.name }}</h5>
          <p class="card-text"><i class="fa fa-2x {{ f.icon }}"></i></p>
        </div>
      </a>

      <div class="card h-100 text-center disabled" *ngIf="f.disabled === true">
        <h5 class="card-title">{{ f.name }}</h5>
        <p class="card-text"><i class="fa fa-2x {{ f.icon }}"></i></p>
      </div>
    </div>
    <!-- // cols-->
  </div>
  <!-- // row-->

  <h1
    *ngIf="(links | permission: currentUser.permissions).length > 0"
    class="mt-4 text-primary"
  >
    Links
  </h1>
  <h1
    *ngIf="(links | permission: currentUser.permissions).length === 0"
    class="mt-4"
  ></h1>
  <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4">
    <div
      class="col"
      *ngFor="let f of links | permission: currentUser.permissions"
    >
      <a href="{{ f.path }}" target="_blank" *ngIf="f.disabled === false">
        <div
          class="card h-100 text-center"
          [ngClass]="{ 'dark-skin': darkModeService.isDarkModeOn() }"
        >
          <h5 class="card-title">{{ f.name }}</h5>
          <p class="card-text"><i class="fa fa-2x {{ f.icon }}"></i></p>
        </div>
      </a>

      <div class="card h-100 text-center disabled" *ngIf="f.disabled === true">
        <h5 class="card-title">{{ f.name }}</h5>
        <p class="card-text"><i class="fa fa-2x {{ f.icon }}"></i></p>
      </div>
    </div>
    <!-- // cols-->
  </div>
  <!-- // row-->
</div>
<!-- // container-->
